/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export let TWO_FACTOR_DORMANT_RECOVER_FLOWS = /*#__PURE__*/function (TWO_FACTOR_DORMANT_RECOVER_FLOWS) {
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["ACTIVATION_PHONE"] = "ACTIVATION_PHONE";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["ACTIVATION_PHONE_CODE"] = "ACTIVATION_PHONE_CODE";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["IDENTITY_VERIFICATION_PHONE"] = "IDENTITY_VERIFICATION_PHONE";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["LOADING"] = "LOADING";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["NEW_PHONE"] = "NEW_PHONE";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["NEW_PHONE_CODE"] = "NEW_PHONE_CODE";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["SELECT"] = "SELECT";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["IDENTITY_VERIFICATION_PHONE_SENT"] = "IDENTITY_VERIFICATION_PHONE_SENT";
  TWO_FACTOR_DORMANT_RECOVER_FLOWS["SUPPORT"] = "SUPPORT";
  return TWO_FACTOR_DORMANT_RECOVER_FLOWS;
}({});
export let RECOVERY_REASONS = /*#__PURE__*/function (RECOVERY_REASONS) {
  RECOVERY_REASONS["DORMANT_RECOVERY"] = "DORMANT_RECOVERY";
  RECOVERY_REASONS["MANDATORY_2FA"] = "MANDATORY_2FA";
  RECOVERY_REASONS["STEP_UP_AUTHENTICATION"] = "STEP_UP_AUTHENTICATION";
  return RECOVERY_REASONS;
}({});
export let PHONE_DELIVERY_METHODS = /*#__PURE__*/function (PHONE_DELIVERY_METHODS) {
  PHONE_DELIVERY_METHODS["SMS"] = "SMS";
  PHONE_DELIVERY_METHODS["VOICE"] = "VOICE";
  return PHONE_DELIVERY_METHODS;
}({});
export const SUPPORT_NUMBER = '+1 (855) 700-6000';
let TwoFactorDormantRecoverBaseComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class TwoFactorDormantRecoverBaseComponent extends Component {
  get recoveryReason() {
    return this.args.recoveryReason || this.multipassfeClient.twoFactorRecoveryReason;
  }
  get activationPhone() {
    return this.multipassfeClient.recoveryDetails?.reduce((prev, curr) => prev ?? curr.activation_phone, undefined);
  }
  get activationPhoneExhausted() {
    return !this.activationPhone || !this.multipassfeClient.canUseActivationPhone || this.hasTriedActivationPhone;
  }
  get newPhoneExhausted() {
    return !this.multipassfeClient.canUseNewPhone || this.hasTriedNewPhone;
  }
  get identityVerificationExhausted() {
    return !this.multipassfeClient.canUseIdentityVerificationPhone || this.hasTriedIdentityVerificationPhone;
  }

  /**
   * Show identity verification option if the new phone method failed
   * and identity verification is available
   */
  get showIdentityVerification() {
    return this.newPhoneExhausted;
  }
  get allMethodsExhausted() {
    return this.activationPhoneExhausted && this.newPhoneExhausted && this.identityVerificationExhausted;
  }
  get canUseCustomerSuccess() {
    return this.multipassfeClient.canUseCustomerSuccess;
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _defineProperty(this, "flows", TWO_FACTOR_DORMANT_RECOVER_FLOWS);
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _initializerDefineProperty(this, "flow", _descriptor5, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor6, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor7, this);
    _initializerDefineProperty(this, "hasTriedActivationPhone", _descriptor8, this);
    _initializerDefineProperty(this, "hasTriedIdentityVerificationPhone", _descriptor9, this);
    _initializerDefineProperty(this, "hasTriedNewPhone", _descriptor10, this);
    _initializerDefineProperty(this, "resendingCode", _descriptor11, this);
    _initializerDefineProperty(this, "selectedPhoneDeliveryMethod", _descriptor12, this);
    this.logger.addComponentBreadcrumb('TwoFactorDormantRecoverBaseComponent');
    this.initFlow();
  }
  async initFlow() {
    if (this.args.requiresPrefetch) {
      try {
        await Promise.all([this.multipassfeClient.listRecoveryDetails({
          recoveryReason: this.recoveryReason
        }), this.multipassfeClient.status()]);
      } catch (e) {
        this.logger.sentryError(e);
        this.marketToasts.critical(this.intl.t(this.tPrefix + 'generic_errors.other.unknown'));
        this.flow = this.flows.SUPPORT;
        return;
      }
    }
    this.hasTriedActivationPhone = !this.multipassfeClient.canUseActivationPhone;
    this.hasTriedIdentityVerificationPhone = !this.multipassfeClient.canUseIdentityVerificationPhone;
    this.hasTriedNewPhone = !this.multipassfeClient.canUseNewPhone;
    if (this.multipassfeClient.canUseActivationPhone && this.activationPhone) {
      this.flow = this.flows.ACTIVATION_PHONE;
    } else if (this.multipassfeClient.canUseNewPhone) {
      this.flow = this.flows.NEW_PHONE;
    } else if (this.multipassfeClient.canUseIdentityVerificationPhone) {
      this.flow = this.flows.IDENTITY_VERIFICATION_PHONE;
    } else if (this.args.recoveryReason === RECOVERY_REASONS.STEP_UP_AUTHENTICATION) {
      this.flow = this.flows.SELECT;
    } else {
      this.flow = this.flows.SUPPORT;
    }
  }
  setFlow(newFlow) {
    this.flow = newFlow;
  }
  setPhoneNumber(newPhoneNumber) {
    this.phoneNumber = newPhoneNumber;
  }
  setPhoneNumberDisplay(newPhoneNumberDisplay) {
    this.phoneNumberDisplay = newPhoneNumberDisplay;
  }
  setHasTriedActivationPhone(hasTried) {
    this.hasTriedActivationPhone = hasTried;
  }
  setHasTriedIdentityVerificationPhone(hasTried) {
    this.hasTriedIdentityVerificationPhone = hasTried;
  }
  setHasTriedNewPhone(hasTried) {
    this.hasTriedNewPhone = hasTried;
  }
  setSelectedPhoneDeliveryMethod(newPhoneDeliveryMethod) {
    this.selectedPhoneDeliveryMethod = newPhoneDeliveryMethod;
  }
  redirect() {
    this.multipassfeClient.redirect();
  }
  async resendCodeDebounced() {
    debounce(this, this.resendCode, 500, true);
  }
  async resendCode() {
    if (this.resendingCode) return;
    this.resendingCode = true;
    switch (this.flow) {
      case this.flows.ACTIVATION_PHONE_CODE:
        await this.multipassfeClient.verifyRecoveryDetailActivationPhone({
          phone: this.phoneNumber,
          reason: this.multipassfeClient.twoFactorRecoveryReason,
          delivery_method: this.selectedPhoneDeliveryMethod
        });
        break;
      case this.flows.IDENTITY_VERIFICATION_PHONE:
      case this.flows.IDENTITY_VERIFICATION_PHONE_SENT:
        await this.multipassfeClient.verifyRecoveryDetailIdentityVerificationPhone({
          phone: this.phoneNumber,
          reason: this.multipassfeClient.twoFactorRecoveryReason
        });
        break;
      case this.flows.NEW_PHONE_CODE:
        await this.multipassfeClient.verifyRecoveryDetailNewPhone({
          phone: this.phoneNumber,
          reason: this.multipassfeClient.twoFactorRecoveryReason,
          delivery_method: this.selectedPhoneDeliveryMethod
        });
        break;
      default:
        throw new Error(`Unexpected recovery flow ${this.flow}`);
    }
    this.resendingCode = false;
  }
  navigateToActivationPhone() {
    this.setFlow(this.flows.ACTIVATION_PHONE);
  }
  navigateToIdentityVerificationPhone() {
    this.setFlow(this.flows.IDENTITY_VERIFICATION_PHONE);
  }
  navigateToNewPhone() {
    this.setFlow(this.flows.NEW_PHONE);
  }
  navigateToCode() {
    switch (this.flow) {
      case this.flows.ACTIVATION_PHONE:
        this.setFlow(this.flows.ACTIVATION_PHONE_CODE);
        return;
      case this.flows.NEW_PHONE:
        this.setFlow(this.flows.NEW_PHONE_CODE);
        return;
      default:
        throw new Error(`Unexpected recovery flow ${this.flow}`);
    }
  }
  navigateToSelect() {
    this.setFlow(this.flows.SELECT);
  }
  navigateToSent() {
    this.setFlow(this.flows.IDENTITY_VERIFICATION_PHONE_SENT);
  }
  navigateToSupport() {
    this.setFlow(this.flows.SUPPORT);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.LOADING;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hasTriedActivationPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasTriedIdentityVerificationPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hasTriedNewPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "resendingCode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "selectedPhoneDeliveryMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.phoneDeliveryMethods.SMS;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumberDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumberDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setHasTriedActivationPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHasTriedActivationPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setHasTriedIdentityVerificationPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHasTriedIdentityVerificationPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setHasTriedNewPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHasTriedNewPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "redirect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "redirect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToActivationPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToActivationPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToIdentityVerificationPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToIdentityVerificationPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToNewPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToNewPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToSelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToSent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToSent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToSupport", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToSupport"), _class.prototype), _class);
export { TwoFactorDormantRecoverBaseComponent as default };